var Curriculog = window.Curriculog || {};

Curriculog.Print = Backbone.View.extend({
    events: {},

    initialize: function () {
        this.listenTo(Backbone, 'Print', this.print);
    },

    print: function (options) {
        if (this.printPopup && !this.printPopup.isClosed()) {
            this.printPopup.reload().focus();
            return;
        }

        this.printPopup = new Curriculog.PopupWindow({
            url: '/' + options.object + ':' + options.id + '/print',
            width: 800,
            height: 500
        });
    }

});
